import React from "react";
import { Box, SimpleGrid } from "@mantine/core";

interface TwoColLayoutProps {
  leftChildren: React.ReactNode;
  rightChildren: React.ReactNode;
}

export function TwoColLayout(props: TwoColLayoutProps) {
  return (
    <SimpleGrid cols={{ xs: 1, md: 2 }}>
      <Box flex={1}>{props.leftChildren}</Box>
      <Box flex={1}>{props.rightChildren}</Box>
    </SimpleGrid>
  );
}
